module.exports = __webpack_public_path__ + "img/02-expanded-coverage.ebf3b13b.png";